var map = {
	".": 13782,
	"./": 13782,
	"./defaultAsyncFetch": 10728,
	"./defaultAsyncFetch.js": 10728,
	"./defaultSyncFetch": 8894,
	"./defaultSyncFetch.js": 8894,
	"./index": 13782,
	"./index.js": 13782,
	"node_modules/@graphql-tools/url-loader/esm": 13782,
	"node_modules/@graphql-tools/url-loader/esm/": 13782,
	"node_modules/@graphql-tools/url-loader/esm/defaultAsyncFetch": 10728,
	"node_modules/@graphql-tools/url-loader/esm/defaultAsyncFetch.js": 10728,
	"node_modules/@graphql-tools/url-loader/esm/defaultSyncFetch": 8894,
	"node_modules/@graphql-tools/url-loader/esm/defaultSyncFetch.js": 8894,
	"node_modules/@graphql-tools/url-loader/esm/index": 13782,
	"node_modules/@graphql-tools/url-loader/esm/index.js": 13782
};

function webpackAsyncContext(req) {
	return Promise.resolve().then(function() {
		if(!__webpack_require__.o(map, req)) {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		}

		var id = map[req];
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 71981;
module.exports = webpackAsyncContext;